import { Fragment } from 'react';
import { Stack, Link, Text, Separator, IStackTokens, useTheme } from '@fluentui/react';
import { Supporter } from '../api/generated/data-contracts';
import { createNewGuid } from '../components/Utils';
import { useSupporters } from '../Configuration/config/components/HelpConfig/useSupporters';

const stackTokens: IStackTokens = { childrenGap: 12 };

const defaultSupport: Supporter[] = [
    {
        header: 'Contact',
        description: 'If you cannot find answers in the Video/Guide/FAQ, please contact us on one of the methods below.',
        web: 'https://projectumsupport.freshdesk.com/a/forums',
        email: 'mail@projectum.com',
        call: '+45 2613 7433',
        order: 1,
        id: createNewGuid(),
    },
];

function HelpSupport() {
    const theme = useTheme();
    const { data: support } = useSupporters({ suspense: true });

    return (
        <div>
            <br />
            <Stack verticalAlign="center" horizontalAlign="center" tokens={stackTokens} style={{ color: theme.semanticColors.bodyText, padding: 15 }}>
                {(support.length ? support : defaultSupport).map(sup => {
                    return (
                        <Fragment key={sup.id}>
                            <Text
                                styles={{
                                    root: {
                                        color: theme.semanticColors.bodyText,
                                    },
                                }}
                                variant="large"
                            >
                                {sup.header}
                            </Text>
                            <Separator styles={{ root: { width: '100%' } }} />
                            <Text
                                styles={{
                                    root: {
                                        color: theme.semanticColors.bodyText,
                                    },
                                }}
                                variant="large"
                            >
                                {sup.description}
                            </Text>
                            <Link href={sup.web} target="_blank">
                                Access our support page
                            </Link>
                            <Text
                                styles={{
                                    root: {
                                        color: theme.semanticColors.bodyText,
                                    },
                                }}
                                variant="large"
                            >
                                <a
                                    href={
                                        'mailto:' +
                                        sup.email +
                                        '?subject=Help with Time for Teams&body=Please specify your inquery here and include screenshots if applicable.'
                                    }
                                >
                                    {sup.email}
                                </a>
                            </Text>
                            <Text
                                styles={{
                                    root: {
                                        color: theme.semanticColors.bodyText,
                                    },
                                }}
                                variant="large"
                            >
                                Call us at <a href={'tel:' + sup.call}>{sup.call}</a>
                            </Text>
                        </Fragment>
                    );
                })}
            </Stack>
        </div>
    );
}

export default HelpSupport;
